import request from '@/utils/request'

export function BrochureList(params) {
    return request({
      url: '/brochure/index',
      method: 'get',
        params
    })
  }
export function BrochureCateList(params={}) {
    return request({
      url: '/brochure/cate',
      method: 'get',
        params
    })
  }

  